/**
 * WARNING: Нельзя использовать в качестве значения какую-либо энамку,
 * так как метод используется для подготовки данных для нескольких ручек.
 */
const SERVICE_TYPES: { [key: string]: string } = {
  Top3: 'top3',
  PremiumObject: 'premium',
  DebitObject: 'paid',
  standard: 'standard',
  FreeObject: 'free',
  auction: 'auction',
};

/**
 * Преобразует шарповые (internal) типы услуг в питонячие (public)
 */
export const mapInternalServiceType = (serviceType: string): string | undefined => {
  return SERVICE_TYPES[serviceType];
};
